import React, { useContext } from 'react';
import { Image, StyleSheet } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { TRAIN_IMAGES } from '../../constants/image';
import { TRAIN_HEIGHT, TRAIN_WIDTH } from '../../constants/size';
import SoundsContext from '../../contexts/SoundsContext';

const styles = StyleSheet.create({
	image: {
		width: TRAIN_WIDTH,
		height: TRAIN_HEIGHT,
	},
});

const Train: React.VFC = () => {
	const sounds = useContext(SoundsContext);

	const handlePressIn = () => {
		const random = 1 + Math.floor(Math.random() * 3);
		switch (random) {
			case 1:
				sounds?.play('horn1');
				break;
			case 2:
				sounds?.play('horn2');
				break;
			case 3:
			default:
				sounds?.play('horn3');
				break;
		}
	};

	return (
		<TouchableOpacity onPressIn={handlePressIn}>
			<Image
				style={styles.image}
				source={TRAIN_IMAGES[0]}
				resizeMode="center"
			/>
		</TouchableOpacity>
	);
};

export default Train;
